module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAqklEQVQoU42RIQ4DIRBFwSEreiHkQLEkFRU9QU/R26yoA1ezh9gmFZXrF0n4DUk3IWS7gBr+zAv/M5wVx3t/A3AQQtyllLHsrTUvRecc8h3AEEK4WmtDDW0Cv6FxWRaqoT0gc1NKSWqt511LlY03Y+xERK+st15YWU9E1AtEAGel1NADBAAXpdSjJ0P+0uxkLDP9yzDHGKUxZmrt4QngyDk3RPRpbnproNa+dadaDVVId6cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/judicialService/icon-right-jt.png
// module id = /84/
// module chunks = 23 24 27 29 31 50 60 67 68 69 70 71 78 79 80 81 104